import { Box, Skeleton } from '@mui/material'
import {
  StyledAppointmentCard,
  AppointmentDetails,
  AppointmentInfo,
  AppointmentFirstRow,
} from '@/components/donation/appointment-card/styled'
import {
  StyledPageTitle,
  StyledDonorSummary,
  StyledSummaryGreeting,
  StyledSummaryGrid,
  StyledSummaryCard,
  StyledIconWrapper,
  StyledSectionTitle,
} from './styled'

export const AppointmentCardSkeleton = ({ isUpcoming = false }) => (
  <StyledAppointmentCard>
    <AppointmentDetails>
      <AppointmentInfo>
        <AppointmentFirstRow>
          <Skeleton variant='text' width={100} height={24} />
          <Skeleton variant='text' width={80} height={24} />
          <Skeleton variant='text' width={400} height={24} />
          <Skeleton
            variant='text'
            width={120}
            height={24}
            style={{ marginLeft: '200px' }}
          />
        </AppointmentFirstRow>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
          <Skeleton variant='text' width={250} height={20} />
          <Box sx={{ ml: 3 }}>
            <Skeleton variant='text' width={100} height={20} />
          </Box>
        </Box>
      </AppointmentInfo>
      {isUpcoming && (
        <Box sx={{ ml: 'auto' }}>
          <Skeleton variant='rounded' width={80} height={36} />
        </Box>
      )}
    </AppointmentDetails>
  </StyledAppointmentCard>
)

export const AppointmentsSkeleton = ({ count = 3, isUpcoming = false }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <AppointmentCardSkeleton
        key={`skeleton-${index}`}
        isUpcoming={isUpcoming}
      />
    ))}
  </>
)

export const DonorSummarySkeleton = () => (
  <StyledDonorSummary>
    <StyledSummaryGreeting>
      <Skeleton variant='text' width={250} height={24} />
    </StyledSummaryGreeting>
    <StyledSummaryGrid>
      {[1, 2, 3].map(index => (
        <StyledSummaryCard key={`summary-skeleton-${index}`}>
          <StyledIconWrapper>
            <Skeleton variant='circular' width={32} height={32} />
          </StyledIconWrapper>
          <Skeleton variant='text' width={150} height={20} />
        </StyledSummaryCard>
      ))}
    </StyledSummaryGrid>
  </StyledDonorSummary>
)

export const PageTitleSkeleton = () => (
  <StyledPageTitle>
    <Skeleton variant='text' width={200} height={40} />
  </StyledPageTitle>
)

export const SectionTitleSkeleton = () => (
  <StyledSectionTitle>
    <Skeleton variant='text' width={300} height={28} />
  </StyledSectionTitle>
)

export const AppointmentsPageSkeleton = () => (
  <>
    <PageTitleSkeleton />
    <DonorSummarySkeleton />
    <SectionTitleSkeleton />
    <AppointmentsSkeleton count={3} isUpcoming={true} />
    <SectionTitleSkeleton />
    <AppointmentsSkeleton count={3} isUpcoming={false} />
  </>
)
